<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_awb") }}</h5>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_1_airport_code"
        :placeholder="$t('message.contracts.awb_1_airport_code')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_1_airport_code"
      />
      <label for="awb_1_airport_code" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_1_airport_code")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_1a_acompany_code"
        :placeholder="$t('message.contracts.awb_1a_acompany_code')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_1a_acompany_code"
      />
      <label
        for="awb_1a_acompany_code"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_1a_acompany_code") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_1b_serial_num"
        :placeholder="$t('message.contracts.awb_1b_serial_num')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_1b_serial_num"
      />
      <label for="awb_1b_serial_num" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_1b_serial_num")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_1c_acomp_name_addr"
        :placeholder="$t('message.contracts.awb_1c_acomp_name_addr')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_1c_acomp_name_addr"
      />
      <label
        for="awb_1c_acomp_name_addr"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_1c_acomp_name_addr") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_2_sender_name_addr"
        :placeholder="$t('message.contracts.awb_2_sender_name_addr')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_2_sender_name_addr"
      />
      <label
        for="awb_2_sender_name_addr"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_2_sender_name_addr") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_4_recipient_name_addr"
        :placeholder="$t('message.contracts.awb_4_recipient_name_addr')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_4_recipient_name_addr"
      />
      <label
        for="awb_4_recipient_name_addr"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_4_recipient_name_addr") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_6_agent_name_addr"
        :placeholder="$t('message.contracts.awb_6_agent_name_addr')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_6_agent_name_addr"
      />
      <label
        for="awb_6_agent_name_addr"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_6_agent_name_addr") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_7_agent_iata_code"
        :placeholder="$t('message.contracts.awb_7_agent_iata_code')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_7_agent_iata_code"
      />
      <label
        for="awb_7_agent_iata_code"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_7_agent_iata_code") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_8_agent_acc"
        :placeholder="$t('message.contracts.awb_8_agent_acc')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_8_agent_acc"
      />
      <label for="awb_8_agent_acc" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_8_agent_acc")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_9_dest_airport"
        :placeholder="$t('message.contracts.awb_9_dest_airport')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_9_dest_airport"
      />
      <label for="awb_9_dest_airport" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_9_dest_airport")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_10_payment_data"
        :placeholder="$t('message.contracts.awb_10_payment_data')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_10_payment_data"
      />
      <label for="awb_10_payment_data" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_10_payment_data")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11a_first_carrier_dest_point"
        :placeholder="$t('message.contracts.awb_11a_first_carrier_dest_point')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11a_first_carrier_dest_point"
      />
      <label
        for="awb_11a_first_carrier_dest_point"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11a_first_carrier_dest_point") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11b_fist_carrier_name"
        :placeholder="$t('message.contracts.awb_11b_fist_carrier_name')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11b_fist_carrier_name"
      />
      <label
        for="awb_11b_fist_carrier_name"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11b_fist_carrier_name") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11c_second_carrier_dest_point"
        :placeholder="$t('message.contracts.awb_11c_second_carrier_dest_point')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11c_second_carrier_dest_point"
      />
      <label
        for="awb_11c_second_carrier_dest_point"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11c_second_carrier_dest_point") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11d_second_carrier_name"
        :placeholder="$t('message.contracts.awb_11d_second_carrier_name')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11d_second_carrier_name"
      />
      <label
        for="awb_11d_second_carrier_name"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11d_second_carrier_name") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11e_third_carrier_dest_point"
        :placeholder="$t('message.contracts.awb_11e_third_carrier_dest_point')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11e_third_carrier_dest_point"
      />
      <label
        for="awb_11e_third_carrier_dest_point"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11e_third_carrier_dest_point") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_11f_third_carrier_name"
        :placeholder="$t('message.contracts.awb_11f_third_carrier_name')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_11f_third_carrier_name"
      />
      <label
        for="awb_11f_third_carrier_name"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_11f_third_carrier_name") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_12_curr_code"
        :placeholder="$t('message.contracts.awb_12_curr_code')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_12_curr_code"
      />
      <label for="awb_12_curr_code" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_12_curr_code")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_14a_pr_o"
        :placeholder="$t('message.contracts.awb_14a_pr_o')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_14a_pr_o"
      />
      <label for="awb_14a_pr_o" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_14a_pr_o")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_14b_col_l"
        :placeholder="$t('message.contracts.awb_14b_col_l')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_14b_col_l"
      />
      <label for="awb_14b_col_l" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_14b_col_l")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_15a_pr_d"
        :placeholder="$t('message.contracts.awb_15a_pr_d')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_15a_pr_d"
      />
      <label for="awb_15a_pr_d" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_15a_pr_d")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_15b_col_l"
        :placeholder="$t('message.contracts.awb_15b_col_l')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_15b_col_l"
      />
      <label for="awb_15b_col_l" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_15b_col_l")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_16_decl_value_carr"
        :placeholder="$t('message.contracts.awb_16_decl_value_carr')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_16_decl_value_carr"
      />
      <label
        for="awb_16_decl_value_carr"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_16_decl_value_carr") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_17_decl_value_cust"
        :placeholder="$t('message.contracts.awb_17_decl_value_cust')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_17_decl_value_cust"
      />
      <label
        for="awb_17_decl_value_cust"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_17_decl_value_cust") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_18_dest_airport"
        :placeholder="$t('message.contracts.awb_18_dest_airport')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_18_dest_airport"
      />
      <label for="awb_18_dest_airport" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_18_dest_airport")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_19ab_flight_date"
        :placeholder="$t('message.contracts.awb_19ab_flight_date')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_19ab_flight_date"
      />
      <label
        for="awb_19ab_flight_date"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_19ab_flight_date") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_20_insuranse_amount"
        :placeholder="$t('message.contracts.awb_20_insuranse_amount')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_20_insuranse_amount"
      />
      <label
        for="awb_20_insuranse_amount"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_20_insuranse_amount") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_21_handling_info"
        :placeholder="$t('message.contracts.awb_21_handling_info')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_21_handling_info"
      />
      <label
        for="awb_21_handling_info"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_21_handling_info") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_21a_custom_status"
        :placeholder="$t('message.contracts.awb_21a_custom_status')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_21a_custom_status"
      />
      <label
        for="awb_21a_custom_status"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_21a_custom_status") }}</label
      >
    </span>
    <h5>{{ $t("message.contracts.awb_22a_group") }}</h5>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22a_pieses_no"
        :placeholder="$t('message.contracts.awb_22a_pieses_no')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22a_pieses_no"
      />
      <label for="awb_22a_pieses_no" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22a_pieses_no")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22b_brutto"
        :placeholder="$t('message.contracts.awb_22b_brutto')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22b_brutto"
      />
      <label for="awb_22b_brutto" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22b_brutto")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22c_measure"
        :placeholder="$t('message.contracts.awb_22c_measure')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22c_measure"
      />
      <label for="awb_22c_measure" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22c_measure")
      }}</label>
    </span>

    <span
      :class="[
        'bmd-form-group mb-2 mt-2 d-block form-label-group',
        awb_22c_measure_focus ? 'focused' : '',
      ]"
    >
      <v-select-popup
        type="measure"
        :placeholder="$t('message.contracts.awb_22c_measure')"
        v-model="awb.awb_22c_measure"
      />

      <!-- <v-select id="awb_22c_measure" :options="measures" label="display_text" :class="['form-control', typeof awb.awb_22c_measure !== 'undefined' && awb.awb_22c_measure.value!==''?'vs--selected':'']" v-model="awb.awb_22c_measure" :placeholder="$t('message.contracts.awb_22c_measure')" @focus="awb_22c_measure_focus=true" @blur="awb_22c_measure_focus=false" @search="fetchMeasures"></v-select>	
       		<label for="awb_22c_measure" class="form-label-group-label shorter">{{$t('message.contracts.awb_22c_measure')}}</label> -->
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22d_rate_class"
        :placeholder="$t('message.contracts.awb_22d_rate_class')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22d_rate_class"
      />
      <label for="awb_22d_rate_class" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22d_rate_class")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22e_commodity_item"
        :placeholder="$t('message.contracts.awb_22e_commodity_item')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22e_commodity_item"
      />
      <label
        for="awb_22e_commodity_item"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22e_commodity_item") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22f_chargeable_weight"
        :placeholder="$t('message.contracts.awb_22f_chargeable_weight')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22f_chargeable_weight"
      />
      <label
        for="awb_22f_chargeable_weight"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22f_chargeable_weight") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22g_rate_charge"
        :placeholder="$t('message.contracts.awb_22g_rate_charge')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22g_rate_charge"
      />
      <label for="awb_22g_rate_charge" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22g_rate_charge")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22h_total"
        :placeholder="$t('message.contracts.awb_22h_total')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22h_total"
      />
      <label for="awb_22h_total" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_22h_total")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22i_nature_quant"
        :placeholder="$t('message.contracts.awb_22i_nature_quant')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22i_nature_quant"
      />
      <label
        for="awb_22i_nature_quant"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22i_nature_quant") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22j_total_pieses"
        :placeholder="$t('message.contracts.awb_22j_total_pieses')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22j_total_pieses"
      />
      <label
        for="awb_22j_total_pieses"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22j_total_pieses") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22l_total_sum_rev"
        :placeholder="$t('message.contracts.awb_22l_total_sum_rev')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22l_total_sum_rev"
      />
      <label
        for="awb_22l_total_sum_rev"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22l_total_sum_rev") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_22k_total_brutto"
        :placeholder="$t('message.contracts.awb_22k_total_brutto')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_22k_total_brutto"
      />
      <label
        for="awb_22k_total_brutto"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_22k_total_brutto") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_23_other_charges"
        :placeholder="$t('message.contracts.awb_23_other_charges')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_23_other_charges"
      />
      <label
        for="awb_23_other_charges"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_23_other_charges") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_24_weight_charge_sum"
        :placeholder="$t('message.contracts.awb_24_weight_charge_sum')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_24_weight_charge_sum"
      />
      <label
        for="awb_24_weight_charge_sum"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_24_weight_charge_sum") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_25_valuation_sum"
        :placeholder="$t('message.contracts.awb_25_valuation_sum')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_25_valuation_sum"
      />
      <label
        for="awb_25_valuation_sum"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_25_valuation_sum") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_26_tax_sum"
        :placeholder="$t('message.contracts.awb_26_tax_sum')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_26_tax_sum"
      />
      <label for="awb_26_tax_sum" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_26_tax_sum")
      }}</label>
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_27_total_other_charges"
        :placeholder="$t('message.contracts.awb_27_total_other_charges')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_27_total_other_charges"
      />
      <label
        for="awb_27_total_other_charges"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_27_total_other_charges") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_28_carrier_total_other_charges"
        :placeholder="
          $t('message.contracts.awb_28_carrier_total_other_charges')
        "
        autocomplete="off"
        style="cursor: auto"
        id="awb_28_carrier_total_other_charges"
      />
      <label
        for="awb_28_carrier_total_other_charges"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_28_carrier_total_other_charges") }}</label
      >
    </span>

    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_30_total_prepaid_collect"
        :placeholder="$t('message.contracts.awb_30_total_prepaid_collect')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_30_total_prepaid_collect"
      />
      <label
        for="awb_30_total_prepaid_collect"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_30_total_prepaid_collect") }}</label
      >
    </span>
    <h5>{{ $t("message.contracts.awb_31") }}</h5>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_32a_awb_create_date"
        :placeholder="$t('message.contracts.awb_32a_awb_create_date')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_32a_awb_create_date"
      />
      <label
        for="awb_32a_awb_create_date"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.awb_32a_awb_create_date") }}</label
      >
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_32b_awb_place"
        :placeholder="$t('message.contracts.awb_32b_awb_place')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_32b_awb_place"
      />
      <label for="awb_32b_awb_place" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_32b_awb_place")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="awb.awb_32c_signature"
        :placeholder="$t('message.contracts.awb_32c_signature')"
        autocomplete="off"
        style="cursor: auto"
        id="awb_32c_signature"
      />
      <label for="awb_32c_signature" class="form-label-group-label shorter">{{
        $t("message.contracts.awb_32c_signature")
      }}</label>
    </span>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button> -->
    </div>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  data() {
    return {
      buttons_loading: false,

      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],

      percent_focused: false,
      discount_focused: false,

      awb_22c_measure_focus: false,

      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      awb: {
        awb_1_airport_code: "",
        awb_1a_acompany_code: "",
        awb_1b_serial_num: "",
        awb_1c_acomp_name_addr: "",
        awb_2_sender_name_addr: "",
        awb_4_recipient_name_addr: "",
        awb_6_agent_name_addr: "",
        awb_7_agent_iata_code: "",
        awb_8_agent_acc: "",
        awb_9_dest_airport: "",
        awb_10_payment_data: "",
        awb_11a_first_carrier_dest_point: "",
        awb_11b_fist_carrier_name: "",
        awb_11c_second_carrier_dest_point: "",
        awb_11d_second_carrier_name: "",
        awb_11e_third_carrier_dest_point: "",
        awb_11f_third_carrier_name: "",
        awb_12_curr_code: "",
        awb_14a_pr_o: "",
        awb_14b_col_l: "",
        awb_15a_pr_d: "",
        awb_15b_col_l: "",
        awb_16_decl_value_carr: "",
        awb_17_decl_value_cust: "",
        awb_18_dest_airport: "",
        awb_19ab_flight_date: "",
        awb_20_insuranse_amount: "",
        awb_21_handling_info: "",
        awb_21a_custom_status: "",
        awb_22a_pieses_no: "",
        awb_22b_brutto: "",
        awb_22c_measure: { value: "" },
        awb_22d_rate_class: "",
        awb_22e_commodity_item: "",
        awb_22f_chargeable_weight: "",
        awb_22g_rate_charge: "",
        awb_22h_total: "",
        awb_22i_nature_quant: "",
        awb_22j_total_pieses: "",
        awb_22l_total_sum_rev: "",
        awb_22k_total_brutto: "",
        awb_23_other_charges: "",
        awb_24_weight_charge_sum: "",
        awb_25_valuation_sum: "",
        awb_26_tax_sum: "",
        awb_27_total_other_charges: "",
        awb_28_carrier_total_other_charges: "",
        awb_30_total_prepaid_collect: "",
        awb_32a_awb_create_date: "",
        awb_32b_awb_place: "",
        awb_32c_signature: "",
      },

      Invoice: {
        DocumentNumber: "",
        DocumentDate: "",
        CurrencyCode: "",
        PlacesQuantity: "",
        PlacesDescription: "",
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        GCost: "",
        Discount: "",
        TransportCharges: "",
        InsuranceCharges: "",
        OtherCharges: "",
        TotalCost: "",
        PaymentPeriod: "",
        InvoiceByer: { value: "" },
        InvoiceSeller: { value: "" },
      },
      InvoiceGoods: [],
      InvoiceGood: {
        GoodMarking: "",
        GoodsCode: { value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "" },
        ServiceCharge: "",
        TransportCharges: "",
        OtherCharges: "",
      },
      product_fields: [
        {
          key: "GoodMarking",
          label: this.$t("message.contracts.invoice_products_GoodMarking"),
          sortable: false,
        },
        {
          key: "GoodsCode",
          label: this.$t("message.contracts.invoice_products_GoodsCode"),
          sortable: false,
        },
        {
          key: "Price",
          label: this.$t("message.contracts.invoice_products_Price"),
          sortable: false,
        },
        {
          key: "GoodsQuantity",
          label: this.$t("message.contracts.invoice_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GrossWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_GrossWeightQuantity",
          ),
          sortable: true,
        },
        {
          key: "NetWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_NetWeightQuantity",
          ),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    addByer() {
      this.$bvModal.show("modal-add-buyer");
    },
    addSeller() {
      this.$bvModal.show("modal-add-seller");
    },
    findLibValueProduct(lib, value, field, index) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.InvoiceGoods[index], field, item);
              }
            });
          });
      }
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.Invoice, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value.trim().toLowerCase() == value.trim().toLowerCase())
            this.$set(this.Invoice, field, item);
        });
      }
    },
    saveProduct() {
      // this.$v.$touch('InvoiceGood')
      if (this.$v.InvoiceGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        this.product_error = false;
        this.hideEditProduct();
      }
    },
    hideEditProduct() {
      this.InvoiceGood = {
        GoodMarking: "",
        GoodsCode: { display_text: "", value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "", display_text: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "", display_text: "" },
        ServiceCharges: "",
        TransportCharges: "",
        OtherCharges: "",
      };
      this.edit_product = false;
    },
    editProduct(index) {
      this.edit_product = true;
      this.InvoiceGood = this.InvoiceGoods[index];
      this.currently_editing = index;
    },
    removeProduct(index) {
      this.InvoiceGoods.splice(index, 1);
    },
    addProduct() {
      this.$v.$touch("InvoiceGood");
      if (this.$v.InvoiceGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;

        this.InvoiceGoods.push({
          GoodMarking: this.InvoiceGood.GoodMarking,
          GoodsCode: this.InvoiceGood.GoodsCode,
          GoodsDescription: this.InvoiceGood.GoodsDescription,
          GoodsQuantity: this.InvoiceGood.GoodsQuantity,
          SupplementaryQualifierName:
            this.InvoiceGood.SupplementaryQualifierName,
          GrossWeightQuantity: this.InvoiceGood.GrossWeightQuantity,
          NetWeightQuantity: this.InvoiceGood.NetWeightQuantity,
          Price: this.InvoiceGood.Price,
          Discount: this.InvoiceGood.Discount,
          DiscountPercentage: this.InvoiceGood.DiscountPercentage,
          OriginCountryCode: this.InvoiceGood.OriginCountryCode,
          ServiceCharges: this.InvoiceGood.ServiceCharges,
          TransportCharges: this.InvoiceGood.TransportCharges,
          OtherCharges: this.InvoiceGood.OtherCharges,
        });
        this.hideAddProduct();
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.InvoiceGood = {
        GoodMarking: "",
        GoodsCode: { display_text: "", value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "", display_text: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "", display_text: "" },
        ServiceCharges: "",
        TransportCharges: "",
        OtherCharges: "",
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    findTNVED(code, index) {
      axios
        .get(
          window.base +
            "/library/tnved?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(this.InvoiceGoods[index], "GoodsCode", response.data[0]);
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    load() {
      axios
        .get(window.base + "/Document/LoadAWB/?doc_id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);
          this.awb.awb_1_airport_code = response.data.awb_1_airport_code;
          this.awb.awb_1a_acompany_code = response.data.awb_1a_acompany_code;
          this.awb.awb_1b_serial_num = response.data.awb_1b_serial_num;
          this.awb.awb_1c_acomp_name_addr =
            response.data.awb_1c_acomp_name_addr;
          this.awb.awb_2_sender_name_addr =
            response.data.awb_2_sender_name_addr;
          this.awb.awb_4_recipient_name_addr =
            response.data.awb_4_recipient_name_addr;
          this.awb.awb_6_agent_name_addr = response.data.awb_6_agent_name_addr;
          this.awb.awb_7_agent_iata_code = response.data.awb_7_agent_iata_code;
          this.awb.awb_8_agent_acc = response.data.awb_8_agent_acc;
          this.awb.awb_9_dest_airport = response.data.awb_9_dest_airport;
          this.awb.awb_10_payment_data = response.data.awb_10_payment_data;
          this.awb.awb_11a_first_carrier_dest_point =
            response.data.awb_11a_first_carrier_dest_point;
          this.awb.awb_11b_fist_carrier_name =
            response.data.awb_11b_fist_carrier_name;
          this.awb.awb_11c_second_carrier_dest_point =
            response.data.awb_11c_second_carrier_dest_point;
          this.awb.awb_11d_second_carrier_name =
            response.data.awb_11d_second_carrier_name;
          this.awb.awb_11e_third_carrier_dest_point =
            response.data.awb_11e_third_carrier_dest_point;
          this.awb.awb_11f_third_carrier_name =
            response.data.awb_11f_third_carrier_name;
          this.awb.awb_12_curr_code = response.data.awb_12_curr_code;
          this.awb.awb_14a_pr_o = response.data.awb_14a_pr_o;
          this.awb.awb_14b_col_l = response.data.awb_14b_col_l;
          this.awb.awb_15a_pr_d = response.data.awb_15a_pr_d;
          this.awb.awb_15b_col_l = response.data.awb_15b_col_l;
          this.awb.awb_16_decl_value_carr =
            response.data.awb_16_decl_value_carr;
          this.awb.awb_17_decl_value_cust =
            response.data.awb_17_decl_value_cust;
          this.awb.awb_18_dest_airport = response.data.awb_18_dest_airport;
          this.awb.awb_19ab_flight_date = response.data.awb_19ab_flight_date;
          this.awb.awb_20_insuranse_amount =
            response.data.awb_20_insuranse_amount;
          this.awb.awb_21_handling_info = response.data.awb_21_handling_info;
          this.awb.awb_21a_custom_status = response.data.awb_21a_custom_status;
          this.awb.awb_22a_pieses_no = response.data.awb_22a_pieses_no;
          this.awb.awb_22b_brutto = response.data.awb_22b_brutto;
          this.awb.awb_22c_measure = response.data.awb_22c_measure;
          this.awb.awb_22d_rate_class = response.data.awb_22d_rate_class;
          this.awb.awb_22e_commodity_item =
            response.data.awb_22e_commodity_item;
          this.awb.awb_22f_chargeable_weight =
            response.data.awb_22f_chargeable_weight;
          this.awb.awb_22g_rate_charge = response.data.awb_22g_rate_charge;
          this.awb.awb_22h_total = response.data.awb_22h_total;
          this.awb.awb_22i_nature_quant = response.data.awb_22i_nature_quant;
          this.awb.awb_22j_total_pieses = response.data.awb_22j_total_pieses;
          this.awb.awb_22l_total_sum_rev = response.data.awb_22l_total_sum_rev;
          this.awb.awb_22k_total_brutto = response.data.awb_22k_total_brutto;
          this.awb.awb_23_other_charges = response.data.awb_23_other_charges;
          this.awb.awb_24_weight_charge_sum =
            response.data.awb_24_weight_charge_sum;
          this.awb.awb_25_valuation_sum = response.data.awb_25_valuation_sum;
          this.awb.awb_26_tax_sum = response.data.awb_26_tax_sum;
          this.awb.awb_27_total_other_charges =
            response.data.awb_27_total_other_charges;
          this.awb.awb_28_carrier_total_other_charges =
            response.data.awb_28_carrier_total_other_charges;
          this.awb.awb_30_total_prepaid_collect =
            response.data.awb_30_total_prepaid_collect;
          this.awb.awb_32a_awb_create_date =
            response.data.awb_32a_awb_create_date;
          this.awb.awb_32b_awb_place = response.data.awb_32b_awb_place;
          this.awb.awb_32c_signature = response.data.awb_32c_signature;
          // this.Invoice.DocumentNumber = response.data.DocumentNumber
          // this.Invoice.DocumentDate = response.data.DocumentDate
          // this.findLibValue('currency', response.data.CurrencyCode, 'CurrencyCode')
          // this.Invoice.PlacesQuantity = response.data.PlacesQuantity
          // this.Invoice.PlacesDescription = response.data.PlacesDescription.trim()
          // this.Invoice.GrossWeightQuantity = response.data.GrossWeightQuantity
          // this.Invoice.NetWeightQuantity = response.data.NetWeightQuantity
          // this.Invoice.GCost = response.data.GCost
          // this.Invoice.Discount = response.data.Discount
          // this.Invoice.TransportCharges = response.data.TransportCharges
          // this.Invoice.InsuranceCharges = response.data.InsuranceCharges
          // this.Invoice.OtherCharges = response.data.OtherCharges
          // this.Invoice.TotalCost = response.data.TotalCost
          // this.Invoice.PaymentPeriod = response.data.PaymentPeriod
          // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.InvoiceByer).then(response_=>{
          // 	this.Invoice.InvoiceByer = {value: response.data.InvoiceByer, display_text: response_.data.org_name}
          // })
          // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.InvoiceSeller).then(response_=>{
          // 	this.Invoice.InvoiceSeller = {value: response.data.InvoiceSeller, display_text: response_.data.org_name}
          // })
          // // this.findLibValue('company', response.data.InvoiceByer, 'InvoiceByer')
          // // this.findLibValue('company', response.data.InvoiceSeller, 'InvoiceSeller')
          // // this.Invoice.InvoiceByer = response.data.InvoiceByer
          // // this.Invoice.InvoiceSeller = response.data.InvoiceSeller
          // // console.log(response.data.product)
          // response.data.product.forEach((good, index)=>{
          // 	var tmp_good = {
          // 		GoodMarking: good.GoodMarking,
          // 		GoodsDescription: good.GoodsDescription,
          // 		GoodsQuantity: good.GoodsQuantity,
          // 		GrossWeightQuantity: good.GrossWeightQuantity,
          // 		NetWeightQuantity: good.NetWeightQuantity,
          // 		Price: good.Price,
          // 		Discount: good.Discount,
          // 		DiscountPercentage: good.DiscountPercentage,
          // 		ServiceCharges: good.ServiceCharges,
          // 		TransportCharges: good.TransportCharges,
          // 		OtherCharges: good.OtherCharges,
          // 		GoodsCode: {value: good.GoodsCode, display_text: ''},
          // 	}
          // 	this.InvoiceGoods.push(tmp_good)
          // 	this.findTNVED(good.GoodsCode, index)
          // 	// this.findLibValueProduct('tnved', good.GoodsCode, 'GoodsCode', index)
          // 	this.findLibValueProduct('country', good.OriginCountryCode, 'OriginCountryCode', index)
          // 	this.findLibValueProduct('measure', good.SupplementaryQualifierName, 'SupplementaryQualifierName', index)

          // })
        });
    },
    stringifyProducts() {
      var result = [];
      this.InvoiceGoods.forEach((product, index) => {
        var line = "";

        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].NetWeightQuantity=" +
          product.NetWeightQuantity;
        line += "&product[" + index + "].Price=" + product.Price;
        line += "&product[" + index + "].Discount=" + product.Discount;
        line +=
          "&product[" +
          index +
          "].DiscountPercentage=" +
          product.DiscountPercentage;
        line +=
          "&product[" + index + "].ServiceCharges=" + product.ServiceCharges;
        line +=
          "&product[" +
          index +
          "].TransportCharges=" +
          product.TransportCharges;
        line += "&product[" + index + "].OtherCharges=" + product.OtherCharges;
        if (typeof product.GoodsCode !== "undefined")
          line +=
            "&product[" + index + "].GoodsCode=" + product.GoodsCode.value;
        if (typeof product.OriginCountryCode !== "undefined")
          line +=
            "&product[" +
            index +
            "].OriginCountryCode=" +
            product.OriginCountryCode.value;
        if (typeof product.SupplementaryQualifierName !== "undefined")
          line +=
            "&product[" +
            index +
            "].SupplementaryQualifierName=" +
            product.SupplementaryQualifierName.value;

        result.push(line);
      });
      return result.join("&");
    },
    saveDocument() {
      var data = {
        document: this.document,
      };
      // this.$v.$touch()
      // if (this.$v.Invoice.$invalid) {
      // 	this.form_error = true
      // 	setTimeout(()=>{
      // 		if($('.has-danger').length>0)
      // 		$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
      // 	}, 100)
      // }else{
      this.$root.$emit("show-loading");
      this.buttons_loading = true;
      var tmp = this.awb;
      if (typeof tmp.awb_22c_measure !== "undefined")
        tmp.awb_22c_measure = tmp.awb_22c_measure.value;

      var formData = new FormData();
      for (var i in tmp) {
        formData.append(i, tmp[i]);
      }
      formData.append("document_category", "transport");

      // Attach file
      formData.append("file", data.document.file);
      // console.log(tmp, data.document, this.stringifyProducts())
      var t1 = this.$t("message.error");
      axios
        .post(
          window.base +
            (this.is_new === true
              ? "/Document/CreateAwb" +
                "?attis_contract_id=" +
                this.$route.params.id
              : "/Document/UpdateAwb" +
                "?attis_contract_id=" +
                this.document_id),
          /*querystring.stringify(tmp)+'&'+this.stringifyProducts()+querystring.stringify(data.document)+'&document_id='+this.document_id+'&document_category=finance', */ formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((response) => {
          if (response.data.trim() == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.awb-created"),
              timeout: 5000,
            }).show();
            this.$root.$emit("loadDocuments", { category: "all" });
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.awb-not-created") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
            if (window.dev_mode) {
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            }
          }
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: t1,
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });

      // }
    },
  },
  mounted() {
    // this.fetchCurrencies('')
    // this.fetchContragents('')
    // this.fetchTNVED('')
    this.fetchMeasures("");
    // this.fetchCountries('')

    if (this.document_id == "new") {
      // var date = new Date()
      // this.Invoice.DocumentNumber = (date.getDate()<10?'0'+date.getDate():date.getDate())+'-'+((date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1))
      // this.Invoice.CurrencyCode = this.contract_details.attis_contract_currency
      // if(this.contract_details.attis_contract_type){
      // 	this.Invoice.InvoiceSeller = this.contract_details.attis_contract_contragent
      // 	axios.get(window.base+'/document/getfirm').then(response=>{
      // 		this.Invoice.InvoiceByer = {value: response.data.org_code, display_text: response.data.org_name}
      // 	})
      // }else{
      // 	this.Invoice.InvoiceByer = this.contract_details.attis_contract_contragent
      // 	axios.get(window.base+'/document/getfirm').then(response=>{
      // 		this.Invoice.InvoiceSeller = {value: response.data.org_code, display_text: response.data.org_name}
      // 	})
      // }
      // if(typeof this.goods !== 'undefined')
      // 	this.goods.forEach(good=>{
      // 		var tmp_good = {}
      // 		tmp_good.GoodsCode = good.attis_cg_TNVED
      // 		tmp_good.GoodsDescription = good.attis_cg_good_name
      // 		tmp_good.GoodsQuantity = good.attis_cg_quantity
      // 		tmp_good.SupplementaryQualifierName = good.attis_cg_measures
      // 		tmp_good.Price = good.attis_cg_price
      // 		this.InvoiceGoods.push(tmp_good)
      // 	})
    } else {
      this.load();
    }

    // this.$root.$on('saveDocument', (data)=>{
    // 	if(typeof data.document.attis_contract_doc_type === 'object'){
    // 		if(data.document.attis_contract_doc_type.value=='invoice'){
    // 			this.saveDocument(data)
    // 		}
    // 	}else{
    // 		if(data.document.attis_contract_doc_type=='invoce'){
    // 			this.saveDocument(data)
    // 		}
    // 	}
    // })
    this.$root.$on("set.buyer.contragent", (data) => {
      this.Invoice.InvoiceByer = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.seller.contragent", (data) => {
      this.Invoice.InvoiceSeller = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {
    Invoice: {
      deep: true,
      handler() {
        var gcost = parseFloat(this.Invoice.GCost);
        var tch = parseFloat(this.Invoice.TransportCharges);
        var ich = parseFloat(this.Invoice.InsuranceCharges);
        var och = parseFloat(this.Invoice.OtherCharges);
        var dscnt = parseFloat(this.Invoice.Discount);

        if (isNaN(gcost)) gcost = 0;
        if (isNaN(tch)) tch = 0;
        if (isNaN(ich)) ich = 0;
        if (isNaN(och)) och = 0;
        if (isNaN(dscnt)) dscnt = 0;
        this.Invoice.TotalCost = gcost + tch + ich + och - dscnt;
      },
    },
    InvoiceGood: {
      deep: true,
      handler() {
        // if(this.percent_focused){
        if (
          parseFloat(this.InvoiceGood.DiscountPercentage) > 0 &&
          !isNaN(parseFloat(this.InvoiceGood.DiscountPercentage))
        ) {
          var qty = parseFloat(this.InvoiceGood.GoodsQuantity);
          var price = parseFloat(this.InvoiceGood.Price);
          var dscp = parseFloat(this.InvoiceGood.DiscountPercentage);
          if (isNaN(qty)) qty = 0;
          if (isNaN(price)) price = 0;
          if (isNaN(dscp)) dscp = 0;
          if (qty > 0)
            this.$set(this.InvoiceGood, "Discount", qty * price * (dscp / 100));
          else this.InvoiceGood.Discount = "";
        }
        // }
      },
    },
    InvoiceGoods: {
      deep: true,
      handler() {
        var sum = 0;
        var gross_weight = 0;
        var net_weight = 0;
        this.InvoiceGoods.forEach((good) => {
          var qty = parseFloat(good.GoodsQuantity);
          var price = parseFloat(good.Price);
          var dscnt = parseFloat(good.Discount);
          var sch = parseFloat(good.ServiceCharges);
          var tch = parseFloat(good.TransportCharges);
          var och = parseFloat(good.OtherCharges);
          var gw = parseFloat(good.GrossWeightQuantity);
          var nw = parseFloat(good.NetWeightQuantity);

          if (isNaN(qty)) qty = 0;
          if (isNaN(price)) price = 0;
          if (isNaN(dscnt)) dscnt = 0;
          if (isNaN(tch)) tch = 0;
          if (isNaN(sch)) sch = 0;
          if (isNaN(och)) och = 0;
          if (isNaN(gw)) gw = 0;
          if (isNaN(nw)) nw = 0;
          sum += qty * price - dscnt + sch + tch + och;
          gross_weight += gw;
          net_weight += nw;
          this.Invoice.GCost = sum;
          this.Invoice.GrossWeightQuantity = gross_weight;
          this.Invoice.NetWeightQuantity = net_weight;
        });
      },
    },
  },
  validations: {
    Invoice: {
      DocumentNumber: {
        required,
      },
      DocumentDate: {
        required,
      },
      GCost: {
        required,
      },
      TotalCost: {
        required,
      },
      InvoiceByer: {
        required,
      },
      InvoiceSeller: {
        required,
      },
    },
    InvoiceGood: {
      Price: {
        required,
      },
    },
  },
};
</script>
